import React from "react";
import useFetch from "hooks/useFetch";
import { useSelector } from "react-redux";
import useGaPageView from "hooks/useGaPageView";
import languages from "languages/languages";
import RestaurantLayout from "components/Layout/RestaurantLayout";
import RestaurantFavourites from "components/Restaurant/RestaurantFavourites";
import RestaurantSlider from "components/Restaurant/RestaurantSlider";
import RestaurantFloors from "components/Restaurant/RestaurantsList";
import styles from "./RestaurantHome.module.css";
import { mainApiPath } from "api/constants";
import { gaSettings } from 'config/constants';

function RestaurantHome() {
  const langState = useSelector((state) => state.language.lang);
  const [error, loading, data] = useFetch(mainApiPath.restaurant);
  const hotDealsTitle = languages[langState]["Ưu đãi hấp dẫn"];
  const shouldTryTitle = languages[langState]["Nên thử"];

  const gaTitle = gaSettings.restaurant.title;
  const gaLocation = gaSettings.restaurant.location;
  useGaPageView({gaTitle, gaLocation});

  return (
    <RestaurantLayout
      error={error}
      loading={loading}
      left={
        <>
          <div className={styles.restaurant_favourites}>
            <RestaurantFavourites
              favourite={data ? data.favourite : null}
              loading={loading}
            />
          </div>

          <div className="d-flex" style={{ margin: "0 -15px" }}>
            <div className="col-6" style={{ paddingRight: "10px" }}>
              <RestaurantSlider
                resSlider={data ? data.should_try : null}
                loading={loading}
                resTitle={shouldTryTitle}
              />
            </div>
            <div className="col-6" style={{ paddingLeft: "10px" }}>
              <RestaurantSlider
                resSlider={data ? data.promotion_interesting : null}
                loading={loading}
                resTitle={hotDealsTitle}
              />
            </div>
          </div>
        </>
      }
      right={
        <>
          <RestaurantFloors list={data ? data.list : null} loading={loading} />
        </>
      }
    />
  );
}
export default RestaurantHome;
